// Modelo Examen de laboratorio.
export default class Device {
    id=""
    name=""
    imei=""
    sim=""
    model=""
    instalationDate=""
    endContractDate=""
    instalationHour=""
    technician=""
    addressInstalation
    status=true
    lastAction=""
    vehicleYear=""
    vehicleBrand=""
    vehicleModel=""
    vehicleNumber=""
    maxSpeed=90
    salesValue=""
    salesIva=""
    salesTotalValue=""
    salesRetention=""
    salesTotalValueRetention=""
    salesPayment=""
    salesPaymentCredit=""
    salesPaymentBalance=""
    salesResponsable=""
    salesFee=""
    salesTechnicianEarning=""
    salesResponsableEarning=""
    salesPrizeEarning=""
    salesNumberInvoice=""
    salesObservation=""
    controlT=""
    activated=true
}



// WEBPACK FOOTER //
// ./src/model/Device.js